import type { AnySection, AnySectionItem } from '@wix/add-panel-common';
import { assocPath, dissocPath } from 'ramda';
import { useProcessed } from '../../../utils/processPlaceholders';

/**
 * We will process section without items.
 * Items will be process separately in corresponding items components.
 */
export const useProcessedSection = (unprocessedSection: AnySection): AnySection =>
  useProcessed(unprocessedSection, (_unprocessedSection, processPlaceholders) => {
    // save original items
    const originalItems = unprocessedSection.props?.items;
    // process without items
    const processedSection = processPlaceholders(dissocPath(['props', 'items'], _unprocessedSection));
    // restore original items
    return assocPath<AnySectionItem[], AnySection>(['props', 'items'], originalItems)(processedSection);
  });
